<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1BE6u9l/tc-custom/9780765396402.jpg?1730585565823" alt="This image is the cover for the book American Hero, The Wild Cards Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">American Hero, The Wild Cards Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Soon to be a show on Hulu!<br/><br/>Rights to develop Wild Cards have been acquired by Universal Cable Productions, the team behind <i>The Magicians</i> and <i>Mr. Robot</i>, with the co-editor of Wild Cards, Melinda Snodgrass, as executive producer.</b><br/><br/>In this bitingly satirical companion novel to the Wild Cards title <i>Inside Straight</i>, <i>American Hero</i> combines two quintessentially pop culture phenomena: superheroes and reality TV. <br/><br/><i>American Hero</i>, the nation’s most highly anticipated competition show, kicks off its first season! People with incredible powers – from possessing death-defying healing to transforming into an insect swarm to shifting the earth itself – have been selected from all walks of life. Their goal: to win one million dollars and the admiration of millions more viewers by answering one question, <br/><br/><i>“Do you have what it takes to be the next American Hero?”</i><br/><br/>Contains week-by-week action-packed recaps and no-holds-bars contestant confessionals, all edited by <i>New York Times</i> #1 bestselling author George R. R. Martin. Features writing by Martin as well as Carrie Vaughn, Melinda M. Snodgrass, Walter Jon Williams, Victor Milan, Daniel Abraham, Stephen Leigh, and many more of the genre’s most innovative writers.<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        George R. R.  Martin
      </h2>
      
      <p class="authorDescription body article">GEORGE R. R. MARTIN is the author of the acclaimed, internationally bestselling fantasy series A Song of Ice and Fire, which is the basis of HBO's popular Game of Thrones television series. Martin has won multiple science fiction awards, including four Hugos, two Nebulas, the Bram Stoker, the Locus Award, the World Fantasy Award, the Daedelus, the Balrog, and the Daikon (Japanese Hugo).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tor Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7e9178ca